import {
  Box,
  Collapse,
  Container,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "../../axios";
import numeral from "numeral";
import sort from "../../utils/sort";
import { currentCurrency } from "../../features/currencySlice";
import { useSelector } from "react-redux";
import cloneDeep from "lodash/cloneDeep";
import { Link } from "react-router-dom";
import LoadingTableRows from "../CoinsTable/LoadingTableRows";
import moment from "moment";

const useStyles = makeStyles({
  table: {},
});

const useTableStyles = makeStyles({
  tableRow: {
    cursor: "pointer",
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#F0F0F0",
    },
  },
});

function Row({ row, curSymbol }) {
  const classes = useTableStyles();
  return (
    <TableRow
      className={classes.tableRow}
      component={Link}
      to={`/exchanges/${row.exchangeId}`}
      style={{ textDecorationLine: "none" }}
    >
      <TableCell align="left">{row.exchangeId}</TableCell>
      <TableCell align="right">{row.pair}</TableCell>
      <TableCell align="right">
        {row.priceUsd > 1
          ? curSymbol + numeral(row.priceUsd).format("0,0.00")
          : curSymbol + numeral(row.priceUsd).format("0.00000000")}
      </TableCell>

      <TableCell align="right">
        {curSymbol + numeral(row.volumeUsd24Hr).format("(0.00a)")}
      </TableCell>
      <TableCell align="right">
        {numeral(row.volumePercent).format("0.00") + "%"}
      </TableCell>
      <TableCell align="right">{moment(row.updated).fromNow()}</TableCell>
    </TableRow>
  );
}

function ExchangeSingleCoin({ symbol }) {
  const [origData, setOrigData] = useState([]);
  const [curData, setCurData] = useState([]);
  const [sortedData, setSortedData] = useState([]);

  const [loading, setLoading] = useState(true);

  const currentCurSelected = useSelector(currentCurrency);

  const [tblHeader, setTblHeader] = useState([
    { id: "exchangeId", label: "Exchange" },
    { id: "pair", label: "Pair" },
    { id: "priceUsd", label: "Price" },
    { id: "volumeUsd24Hr", label: "Volume (24Hr)" },
    { id: "volumePercent", label: "Volume (%)" },
    { id: "update", label: "Updated" },
  ]);

  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();

  const handleSortClick = (cellId) => {
    const isAsc = orderBy === cellId && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(cellId);
  };

  useEffect(() => {
    setInterval(() => {
      axios
        .get(`/assets/${symbol}/markets`)
        .then((res) => {
          setOrigData(res.data.data);
        })
        .catch((err) => console.log(err));
    }, 3000);
  }, []);
  useEffect(() => {
    setCurData(cloneDeep(origData));
  }, [origData]);
  useEffect(() => {
    curData.map((d, index) => {
      d.priceUsd = d.priceUsd / currentCurSelected.rateUsd;
      d.volumeUsd24Hr = d.volumeUsd24Hr / currentCurSelected.rateUsd;
      d.volumePercent = d.volumePercent / currentCurSelected.rateUsd;

      curData[index] = d;
      if (loading === true) setLoading(false);
    });
    //console.log(curData[0]);
    setSortedData(sort(curData, order, orderBy, "coinExchange"));
    //console.log("current currency changed!!", currentCurSelected);
  }, [currentCurSelected, curData, order, orderBy]);
  const classes = useStyles();

  return (
    <TableContainer component={Paper} elevation={10}>
      <Table style={{ widht: 600 }}>
        <TableHead>
          <TableRow>
            {tblHeader.map((header) => {
              return (
                <TableCell
                  align={header.id === "exchangeId" ? "left" : "right"}
                  key={header.id}
                  sortDirection={header.id === orderBy ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === header.id}
                    direction={orderBy === header.id ? order : "asc"}
                    onClick={() => {
                      handleSortClick(header.id);
                    }}
                  >
                    {header.label}
                  </TableSortLabel>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <LoadingTableRows numberOfRow={15} numberOfColumn={6} />
          ) : (
            sortedData.map((row, index) => {
              //if (index === 0) console.log(row);
              const curSymbol =
                currentCurSelected.currencySymbol !== null
                  ? currentCurSelected.currencySymbol
                  : "";

              return <Row row={row} curSymbol={curSymbol} key={row.rank} />;
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ExchangeSingleCoin;
